





















































































































































import { Component, Vue } from "vue-property-decorator";
import { getDate } from "@/utils/utils";
import { getOrderDateils, getDevices, startDetection } from "@/api/api.config";
@Component
export default class my extends Vue {
  orderId: any = null;
  shopData: any = "";
  statusName: any = "";
  showDatetime = false;
  showDevice = false;
  submitBtnDisabled = false;
  currentDate = new Date();
  orderData: any = {
    orderId: null,
    deviceId: null,
    devuceCode: null,
    kv: null,
    kva: null,
    produceDate: null,
    mileage: null,
    enduranceMileage: null,
    connectName: null,
    connectNumber: null,
    carTypeName: null,
    reserveTime: null,
  };
  devices: any = {};

  /**
   * 选择时间确定
   * @param date 选中时间对象
   */
  confirmFn(date: any) {
    this.showDatetime = false;
    this.orderData.produceDate = getDate(date);
  }
  /**
   * 选择时间取消
   */
  cancelFn() {
    this.showDatetime = false;
  }

  /**
   * 获取订单详情
   */
  getOrderDateils() {
    var that = this;
    getOrderDateils({
      orderId: that.$route.query.orderId,
    })
      .then((res) => {
        that.$toast.clear();
        if (res.data.code == "0") {
          that.orderData = res.data.data;
          that.statusFormat(that.orderData.status);
          console.log(that.orderData);
        } else {
          that.$toast.fail(res.data.message);
        }
      })
      .catch((err) => {
        that.$toast.clear();
        that.$toast.fail("订单数据获取失败");
      });
  }

  statusFormat(status: any) {
    switch (status) {
      case 0:
        this.statusName = "已预约";
        break;
      case 2:
        this.statusName = "检测中";
        break;
      case 5:
        this.statusName = "已取消";
        break;
      case 6:
        this.statusName = "检测完成";
        break;
    }
  }

  /**
   * 获取门店所有设备
   */
  getDevices() {
    var that = this;
    getDevices()
      .then((res) => {
        this.$toast.clear();
        if (res.data.code == "0") {
          that.devices = res.data.data;
        } else {
          this.$toast.fail(res.data.message);
        }
      })
      .catch((err) => {
        this.$toast.clear();
        this.$toast.fail("获取门店设备失败");
      });
  }

  /**
   * 设备选择确定
   * @param e 选中设备
   */
  onDeviceConfirm(e: any) {
    this.orderData.deviceCode = e.deviceCode;
    this.orderData.deviceId = e.deviceId;
    this.showDevice = false;
  }

  /**
   * 开始检测
   */

  startDetection() {
    var that = this;
    if (that.required()) {
      that.$toast.loading({
        message: "数据提交中...",
        forbidClick: true,
      });
      startDetection(that.orderData)
        .then((res) => {
          that.$toast.clear();
          if (res.data.code == "0") {
            that.$toast.success("操作成功");
            setTimeout(() => {
              // if (this.shopData === 1) {
              //   that.$router.push({
              //     path: "/my/OrderManagement",
              //   });
              // }
              that.$router.back()
            }, 500);
          } else {
            this.$toast.fail(res.data.message);
          }
        })
        .catch((err) => {
          this.$toast.clear();
          this.$toast.fail("操作失败，请联系管理员");
        });
    }
  }

  required() {
    var flag = true;
    var msg = "";
    if (!this.orderData.enduranceMileage) {
      flag = false;
      msg = "请输入出厂续航";
    } else if (!this.orderData.deviceCode) {
      flag = false;
      msg = "请选择检测设备";
    } else if (!this.orderData.kv) {
      flag = false;
      msg = "请输入额定电压";
    } else if (!this.orderData.kva) {
      flag = false;
      msg = "请输入额定容量";
    } else if (!this.orderData.produceDate) {
      flag = false;
      msg = "请选择生产日期";
    } else if (!this.orderData.mileage) {
      flag = false;
      msg = "请输入表显里程";
    }
    if (!flag) {
      this.$toast.fail(msg);
    }
    return flag;
  }

  back() {
    this.$router.back();
  }

  mounted() {
    this.shopData = localStorage.getItem("shopData");
  }

  created() {
    this.$toast.loading({
      message: "加载中...",
      forbidClick: true,
    });
    this.getOrderDateils();
    this.getDevices();
  }
}
